module.exports = __webpack_public_path__ + "img/fish.8a92c40c.svg";